// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__VYtSL","title":"ClientInsurance_title__162E_","itemText":"ClientInsurance_itemText__1PLCo"};